import { styled, TableHead } from "@mui/material";

export const MyTableHeadStyled = styled(TableHead)(
    ({ theme }) => ({
        background: theme.palette.primary.main,
    })
);